import React, {Suspense, lazy, memo, useEffect, useState, useRef, createRef} from "react";
import axios from "axios";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import ProtectedRoute from "../Components/ProtectedRoute";
import auth from "../Components/Authenticate";
import { io } from 'socket.io-client'
import SocketContext from '@SocketContext'
//import { userMessageService } from "../Components/_services/userMessage.service";
import NaviBarWithSocket from "../Components/NaviBar";
import MessagesComponent from "../Components/MessagesComponent";
//import { useUserMode } from "@UserModeContext";
import pluginsService from "../Services/PluginsService";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingPageComponent from "../Components/LoadingPageComponent";
import setupProperitiesHandler from "../Security/SetupProperitiesHandler";
import { useIdleTimer } from 'react-idle-timer' 
import { sessionMessageService } from "../Components/_services/sessionMessage.service";
import { skip } from "rxjs/internal/operators/skip";
//import moment from "moment";
import LoginModalComponent from "../Components/LoginModalComponent";

import { AuditPagePermissions, CompanyManagePagePermissions, DocConnectedPagePermissions, DocumentsPagePermissions, DocumentsUserModePagePermissions, EditCompanyDataPagePermissions, FirstSetupPagePermissions, JobConnectedPagePermissions, MessagesPagePermissions, OrganizationStructurePagePermissions, PasswordManagmentPagePermissions, PluginManagementPagePermissions, PluginProviderPermissions, UsersPagePermissions, WorkflowinfoPagePermissions, LoginPagePermissions } from "../Helpers/PagesPermissions/pagesPermissions"


const LoginPageWithSocket = lazy(() => import("../Pages/LoginPage/LoginPage"));
const PasswordResetPage = lazy(() => import("../Pages/LoginPage/PasswordResetPage"));
const PasswordChangePage = lazy(() => import("../Pages/LoginPage/PasswordChangePage"));
const OrganizationStructurePage = lazy(() => import("../Pages/OrganizationStructurePage/OrganizationStructurePage"));
const UsersPage = lazy(() => import("../Pages/UsersPage/UsersPage"));
const DocumentsPage = lazy(() => import("../Pages/DocumentsPage/DocumentsPage"));
const DocumentsUserModePage = lazy(() => import("../Pages/DocumentsUserModePage/DocumentsUserModePage"));
const AuditPage = lazy(() => import("../Pages/AuditPage/AuditPage"));
const EditCompanyDataPage = lazy(() => import("../Pages/EditCompanyDataPage/EditCompanyDataPage"));
const MessagesPage = lazy(() => import("../Pages/MessagesPage/MessagesPage"));
const JobConnectedPage = lazy(() => import("../Pages/JobConnectedPage/JobConnectedPage"));
const DocConnectedPage = lazy(() => import("../Pages/DocConnectedPage/DocConnectedPage"));
const WorkflowinfoPage = lazy(() => import("../Plugins/Workflowinfo/WorkflowinfoPage"));
const SzkoleniaPage = lazy(() => import("../Plugins/Szkolenia/SzkoleniaPage"));
const NotFoundPage = lazy(() => import("../Pages/NotFoundPage/NotFoundPage"));
const PasswordManagmentPage = lazy(() => import("../Pages/PasswordManagmentPage/PasswordManagmentPage"));
const PluginProvider = lazy(() => import("../Pages/PluginManagementPage/PluginProvider"));
const PluginManagementPage = lazy(() => import("../Pages/PluginManagementPage/PluginManagementPage"));
const FirstSetupPage = lazy(() => import("../Pages/FirstSetupPage/FirstSetupPage"));
const CompanyManagePage = lazy(() => import("../Pages/CompanyManagePage/CompanyManagePage"));

const OcenaRyzykaComponent = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/OcenaRyzyka/OcenaRyzykaComponent")) : null;
const ActivityLogComponent = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/ActivityLog/ActivityLogComponent")) : null;
const ActivityICTLogComponent = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/ActivityICTLog/ActivityICTLogComponent")) : null;
const MailerComponent = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/Mailer/MailerComponent")) : null;
const ImportExportPage = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/ImportExport/ImportExportPage")) : null;
const StatsPage = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/Stats/StatsPage")) : null;
const DownloadPage = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/Download/DownloadPage")) : null;
const UpowaznieniaPage = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/Upowaznienia/UpowaznieniaPage")) : null;
const WorkflowAttachmentsPage = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/WorkflowAttachments/WorkflowAttachmentsPage")) : null;
const LoggerPage = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/Logger/LoggerPage")) : null;
const DFCMassPrintPage = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/DFCMassPrint/DFCMassPrintPage")) : null;
const TodoList = process.env.NODE_ENV === 'development' ? lazy(() => import("../Plugins/TodoList/TodoListPage")) : null;

const socket = io({
    autoConnect: false,
    secure: false,
    rejectUnauthorized: false,
    path: '/socket.io',
    transports: ['polling','websocket'],
    transportOptions: {
        polling: {
            extraHeaders: {
                'eqsmUserName': auth.loggedIn() ? auth.getUserName() : '',
                'eqsmUserId': auth.loggedIn() ? auth.getUserId() : ''
            }
        },
        websocket: {
            extraHeaders: {
                'eqsmUserName': auth.loggedIn() ? auth.getUserName() : '',
                'eqsmUserId': auth.loggedIn() ? auth.getUserId() : ''
            }
        }
    }
});

const App = () => {
    const [isLoading, setIsLoading] = useState(true);
    /*socket.on('connect', () => {
        console.log('CONNECTED');
        if (auth.loggedIn())
            socket.emit('setuserid', {'json': {'dsad':'sdasd'}}, (data) => {
                console.log(data);
            });
        else {
            console.log('Niezalogowany');
        }
    });*/

    /*socket.on('userregistered', ((data, callback) => {
        console.log(data);
        callback({'data': 'ack'});
    }));*/

    socket.on('connect', () => {
        console.log('Websocket connected');
    });

    socket.on('disconnect', (reason) => {
        console.log('Websocket disconnected', reason);
    });

    socket.on("connect_error", () => {
        setTimeout(() => {
            socket.connect();
        }, 1000);
    });

    axios.interceptors.request.use(
        (config) => {
            const token = (config.url === '/api/v1/refresh-token') ? auth.getRefreshToken() : auth.getToken();
            if (token) {
                config.headers['Authorization'] = 'Bearer ' + token;
            }
            config.headers['Accept'] = 'application/json';
            config.headers['Content-Type'] = 'application/json';
            config.headers['Cache-Control'] = 'no-cache';
            return config;
        },
        (error) => {
            return Promise.reject(error);
        });


    axios.interceptors.response.use((response) => {
        return response
    }, (error) => {
        const originalRequest = error.config;

        if (error.response === undefined)
            return Promise.reject(error);

        if (error.response.status === 401) {
            if (originalRequest.url === '/api/v1/authenticate') //Jeśli błąd logowania - nie odświeżaj refresh tokena
                return Promise.reject(error.response);

            if (originalRequest.url === '/api/v1/refresh-token') { //Jeśli błąd przy odświeżaniu tokena - poproś o logowanie
                sessionMessageService.loginModalDialog({ username: auth.getUserName() });
                return Promise.reject();
            }

            if (!originalRequest._retry) { // Odśwież token
                originalRequest._retry = true;
                return auth.getNewToken()
                    .then(() => {
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + auth.getToken()
                        return axios(originalRequest);
                    })
            }
        }

        return Promise.reject(error.response);
    });

    const onIdle = () => {
        sessionMessageService.loginModalDialog({ username: auth.getUserName() });
    };

    const onAction = () => {
        if (auth.isRefreshTokenExpired()) {
            sessionMessageService.loginModalDialog({ username: auth.getUserName() });
        } else if (auth.isTokenExpired() && !auth.isRefreshTokenExpired()) {
            auth.getNewToken().then((response) => {

            }).catch((error) => {
                console.error(error);
                auth.logout();
            });
        }
    };

    const idleTimer = useIdleTimer({
        onIdle,
        onAction,
        timeout: 1000 * 60 * 30,
        startOnMount: true,
        startManually: false,
        stopOnIdle: true,
        crossTab: true,
        debounce: 250,
        name: 'login-idle-timer'
    });

    useEffect(() => {
        sessionStorage.removeItem("plugins");
        pluginsService.list()
            .then((response) => {
                sessionStorage.setItem("plugins", JSON.stringify(response));
            }).catch((error) => {
                console.error(error);
            });
        const subscription = sessionMessageService.idleTimerService().pipe(skip(1)).subscribe((item) => {
            if (item.logout === true) {
                idleTimer.pause();
                socket.io.opts.autoConnect = false;
                socket.close();
            } else {
                idleTimer.reset();
                socket.io.opts.autoConnect = true;
                socket.io.opts.transportOptions.polling.extraHeaders.eqsmUserName = auth.loggedIn() ? auth.getUserName() : '';
                socket.io.opts.transportOptions.polling.eqsmUserId = auth.loggedIn() ? auth.getUserId() : '';
                socket.io.opts.transportOptions.websocket.extraHeaders.eqsmUserName = auth.loggedIn() ? auth.getUserName() : '';
                socket.io.opts.transportOptions.websocket.eqsmUserId = auth.loggedIn() ? auth.getUserId() : '';
                console.log(socket.io.opts);
                socket.connect();
                console.log(socket.disconnected);
            }
        });
        setupProperitiesHandler.save().then(() => setIsLoading(false))

        if (auth.loggedIn() && socket.disconnected) {
            socket.connect();
        }

        return () => {
            subscription.unsubscribe();
        };
    }, [socket]);

    return (
        <SocketContext.Provider value={socket}>
            <>
                {!isLoading && (
                    <BrowserRouter>
                        <Route render={(location) => {
                            return (
                                <>
                                    {
                                        auth.loggedIn() &&
                                        <>
                                            <NaviBarWithSocket />
                                            <LoginModalComponent />
                                        </>
                                    }
                                    <Suspense fallback={<LoadingPageComponent />}>
                                        <Switch location={location.key}>
                                            <ProtectedRoute exact path="/" />
                                            <ProtectedRoute path="/pierwsza-konfiguracja" component={FirstSetupPage} permissions={FirstSetupPagePermissions}/>
                                            <Route path="/login" component={LoginPageWithSocket} />
                                            <ProtectedRoute path="/password-reset" component={PasswordResetPage} />
                                            <ProtectedRoute path="/password-change-:token" component={PasswordChangePage} />
                                            <ProtectedRoute path="/zarzadzanie-firmami" component={CompanyManagePage} permissions={CompanyManagePagePermissions} />
                                            <ProtectedRoute path="/struktura-organizacyjna" component={OrganizationStructurePage} permissions={OrganizationStructurePagePermissions} />
                                            <ProtectedRoute path="/edycja-dokumentow" component={DocumentsPage} permissions={DocumentsPagePermissions} />
                                            <ProtectedRoute path="/dokumenty" component={DocumentsUserModePage} permissions={DocumentsUserModePagePermissions} />
                                            <ProtectedRoute path="/edycja-danych-firmy" component={EditCompanyDataPage} permissions={EditCompanyDataPagePermissions} />
                                            <ProtectedRoute path="/wiadomosci" component={MessagesPage} permissions={MessagesPagePermissions} />
                                            <ProtectedRoute path="/stanowiska-zwiazane" component={JobConnectedPage} permissions={JobConnectedPagePermissions} />
                                            <ProtectedRoute path="/dokumenty-zwiazane" component={DocConnectedPage} permissions={DocConnectedPagePermissions} />
                                            <ProtectedRoute path="/uzytkownicy" component={UsersPage} permissions={UsersPagePermissions} />
                                            <ProtectedRoute path="/sledzenie-zmian" component={AuditPage} permissions={AuditPagePermissions} />
                                            <ProtectedRoute path="/plugins-management" component={PluginManagementPage} permissions={PluginManagementPagePermissions} />
                                            <ProtectedRoute path="/zarzadzanie-haslami" component={PasswordManagmentPage} permissions={PasswordManagmentPagePermissions} />
                                            <ProtectedRoute path="/plugin-:link" component={PluginProvider} permissions={PluginProviderPermissions} />
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-ocena-ryzyka" component={OcenaRyzykaComponent} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-rejestr-czynnosci" component={ActivityLogComponent} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-rejestr-czynnosci-ict" component={ActivityICTLogComponent} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-mailer" component={MailerComponent} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-workflowinfo" component={WorkflowinfoPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-szkolenia" component={SzkoleniaPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-importexport" component={ImportExportPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-stats" component={StatsPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-download" component={DownloadPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-upowaznienia" component={UpowaznieniaPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-workflowattachments" component={WorkflowAttachmentsPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-logger" component={LoggerPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-dfcmassprint" component={DFCMassPrintPage} />}
                                            {process.env.NODE_ENV === 'development' && <ProtectedRoute path="/dev-plugin-todolist" component={TodoList} />}
                                            <Route component={NotFoundPage} />
                                        </Switch>
                                    </Suspense>
                                    {auth.loggedIn() && <MessagesComponent />}
                                    <ToastContainer theme="colored" />
                                </>
                            );
                        }}
                        />
                    </BrowserRouter>
                )}
                {isLoading && (
                    <LoadingPageComponent />
                )}
            </>
        </SocketContext.Provider>
    );
};

export default memo(App);